import React, {Fragment, useLayoutEffect} from "react"
import TextImage from '../../new-components/templates/text-image'
import ArtBanner from "../../new-components/templates/art-banner";
import PreviousJobs from "../../new-components/templates/previous-jobs";
import HandPicked from '../../new-components/templates/hand-picked'
import ContactUs from "../../new-components/contact-us";
import SendUsMessages from "../../new-components/form/send-us-message/index";
import './style.css'

import {cottonRag, semiGloss, smoothMatt} from "./section-text";
//image
import ImgCottonPaper from "../../images/cotton-rag-paper.jpg"
import ImgSemiGlossPaper from "../../images/semi-gloss-photo-paper.jpg"
import ImgSmoothPaper from "../../images/smooth-matt-paper-copy.jpg"
import MetaTags from "react-meta-tags";

export default function ArtPrinting() {

    useLayoutEffect(() => {
        document.title = "Fine Art Printing Singapore | FrameIT";
    }, [])

    return (
        <Fragment>
            <MetaTags>
                <meta
                    id='meta-description'
                    name='description'
                    content={"We print photographs and digital art for private individuals and companies using the latest technology and a range of high quality, acid free papers"}
                />
                <meta name='robots' content='index'/>
                <meta name='googlebot' content='index'/>
            </MetaTags>
            <main>
                <ArtBanner/>
                <PreviousJobs/>
                <HandPicked container="art-container-md"/>
                <section className="backround  text_image art-container-text-image">
                    <div className="main-container">

                        <TextImage  {...cottonRag}>
                            <img src={ImgCottonPaper} alt="paper"/>
                        </TextImage>
                        <TextImage
                            position="left"
                            {...semiGloss}
                        >
                            <img src={ImgSemiGlossPaper} alt="paper"/>
                        </TextImage>
                    </div>
                </section>
                <section className="art-container-text-image text_image">
                    <div className="main-container">

                        <TextImage {...smoothMatt}>
                            <img src={ImgSmoothPaper} alt="paper"/>
                        </TextImage>
                    </div>
                </section>
                <div className="n-main-container art-page-footer">
                    <ContactUs/>
                    <SendUsMessages/>
                </div>
            </main>
        </Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/page/art-printing/art-printing.js